import platform$1 from './browser/index.js';
import * as utils from './common/utils.js';

function _extends(){_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target};return _extends.apply(this,arguments)}var platform = _extends({},utils,platform$1);

export { platform as default };
//# sourceMappingURL=index.js.map
